<button class="btn btn-primary btn-icon scroll-to-top" [ngClass]="{ 'show-scroll-to-top': windowScrolled }"
  type="button" (click)="scrollToTop()" rippleEffect>
  <span *ngIf="!isLoading"><i [data-feather]="'arrow-up'"></i></span>
  <span *ngIf="isLoading" class="spinner-border spinner-border-sm"></span>
</button>